import { useQuery, UseQueryResult } from '@tanstack/react-query';

import getMyProfile from '@/actions/my-profile/getMyProfile';
import { MyProfile } from '@/types/my-profile.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetMyProfileReturn {
  result: ApiResponse<MyProfile> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetMyProfile = (): UseGetMyProfileReturn => {
  const query: UseQueryResult<ApiResponse<MyProfile> | undefined, Error> =
    useQuery({
      queryKey: ['my-profile'],
      queryFn: getMyProfile,
    });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
